export class ResponsibilityTranslationModel {
    constructor(data = {}) {
        this.full_label = data === null || data === void 0 ? void 0 : data.full_label;
        this.label = data === null || data === void 0 ? void 0 : data.label;
        this.language_id = data === null || data === void 0 ? void 0 : data.language_id;
        this.id = data.id;
        this.responsibility_id = data.responsibility_id;
    }
}
